<section class="main-section form-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/sellerDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/sellerProductsList/">Products</a></li>
      <li class="breadcrumb-item active" aria-label="page">Edit Product</li>
    </ol>
  </nav>
  <div class="row mt-3">
    <div class="col-lg-12">
      <div class="inner-box">
        <h2 class="text-adminStockTransferblack mb-3 d-inline-block">Product Type :</h2>
        <div class="row">
          <div class="col-sm-12 col-md-4 col-lg-4">
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group required">
                  <label class="control-label" for="product">Product</label>
                  <input type="text" id="product" [(ngModel)]="editInventory.productName" maxlength="50"
                         class="form-control" (blur)="typeProduct()" [ngClass]="{'is-invalid':statusText1}"
                         [ngModelOptions]="{standalone:true}" required>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group">
                  <label class="control-label" for="store">Store SKU</label>
                  <input type="text" onkeypress='return event.charCode != 32' id="store"
                         [(ngModel)]="editInventory.storeSku" (blur)="typeStoreSku()"
                         (change)="skuValue()" class="form-control" maxlength="12"
                         [ngClass]="{'is-invalid':statusText12}" [ngModelOptions]="{standalone:true}" required>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-4">
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group required">
                  <label class="control-label" for="hsnCode">HSN Code</label>
                  <input type="text" id="hsnCode" [(ngModel)]="editInventory.hsnCode" maxlength="50"
                         class="form-control" (blur)="typeHsn()" [ngClass]="{'is-invalid':hsnCodeError}"
                         [ngModelOptions]="{standalone: true}" required>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="form-group required">
                  <label class="control-label" for="sku">SKU</label>
                  <input type="text" id="sku" [(ngModel)]="editInventory.sku" maxlength="10"
                         class="form-control" [ngModelOptions]="{standalone:true}" disabled>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-4 col-lg-3">


            <div class="row">
              <a data-toggle="modal" data-target="#upLoadImage" style="cursor:pointer;">
                <img class="d-md-none d-sm-none d-xs-none d-lg-block shift-uploaded-img"
                     src="{{editInventory.imageUrl !=null ? editInventory.imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}"
                     width="200" height="200"/>
              </a>
            </div>
          </div>
        </div>


        <div class="row">
          <div class="col-sm-12 col-md-4 col-lg-4 required">
            <div class="form-group mb-1">
              <label class="control-label">Category</label>
              <ng-select id="accountOwner" [(ngModel)]="category"
                         [ngModelOptions]="{standalone: true}" required
                         [items]="categories"
                         bindLabel="categoryName"
                         (blur)="typeCategory()"
                         [ngClass]="{'is-invalid':categoryError}"
                         [ngClass]="{'service-error':categoryError}"
                         [searchWhileComposing]="true">
              </ng-select>
              <div id="categoryError" class="invalid-feedback d-block shift-invalid-login"
                   [hidden]="!categoryError">{{categoryError}}
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-md-12 mb-1 text-danger fw-500"
         *ngIf="statusText1 || statusText2 || hsnCodeError || minQuantityError || statusText4 || statusText3|| imageUrlError">
      Please
      Enter Mandatory Fields
    </div>

    <div class="col">
      <ul class="list-inline tab-list">

        <li class="list-inline-item"><a (click)=" tabChange('attributes');"
                                        [ngClass]="{'active': tabClicked === 'attributes'}">Attributes
          <span class="dot bg-danger ml-2"
                *ngIf="minQuantityError || statusText1 || statusText2 || hsnCodeError"></span></a></li>

        <li class="list-inline-item" *ngIf="editInventory.productType =='KIT'"><a (click)=" tabChange('component');"
                                                                                  [ngClass]="{'active': tabClicked === 'component'}">Components
          <span class="dot bg-danger ml-2" *ngIf="lengthError || statusText4"></span></a></li>

        <li class="list-inline-item" *ngIf="editInventory.productType !=='PackingMaterial'"><a
          (click)=" tabChange('fulfilment');"
          [ngClass]="{'active': tabClicked === 'fulfilment'}">Fulfilment Details
          <span class="dot bg-danger ml-2" *ngIf=""></span></a></li>
        <li class="list-inline-item"><a (click)=" tabChange('details');"
                                        [ngClass]="{'active': tabClicked === 'details'}">Orders
          <span class="dot bg-danger ml-2" *ngIf=""></span></a></li>
      </ul>
      <div class="inner-box">

        <div class="" *ngIf="tabClicked == 'component'">
          <div class="row">
            <div class="col-lg-4 col-sm-6 mt-2 mb-2 required">
              <label class="mb-3">Add Products</label>
            </div>
          </div>
          <div class="table-3">
            <table class="table packing-table packing-table-2">
              <thead class="thead-light">
              <tr>
                <th style="width: 500px">Product Name</th>
                <th style="width: 200px">SKU</th>
                <th style="width: 200px">Quantity</th>
                <th style="width: 200px">Action</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let productLine of productLines; let i=index;">
                <td style="width: 500px">{{productLine.productName}}</td>
                <td class="text-black mb-3" style="text-transform:uppercase;width : 200px;">{{productLine.sku}}
                </td>
                <td style="width: 200px"><input type="text" id="proQuantity" [(ngModel)]="productLine.quantity"
                                                class="form-control width-120"
                                                onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                [ngModelOptions]="{standalone: true}" required>
                </td>
                <td style="width: 200px">
                  <a (click)="submitKitDelete(productLine,i)" style="white-space: nowrap;">
                    <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" height="21" viewBox="0 0 18.877 24.27">
                      <defs>
                        <style>.a {
                          fill: #848484;
                        }</style>
                      </defs>
                      <path class="a"
                            d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z"
                            transform="translate(-7.5 -4.5)"/>
                    </svg>
                    Delete
                  </a>
                </td>

              </tr>

              <tr>
                <td style="width: 500px">
                  <ng-select id="product" [(ngModel)]="productTemp" style="width: 500px;"
                             [ngModelOptions]="{standalone: true}" required (open)="open()"
                             [items]="selectedProducts"
                             bindLabel="productName"
                             placeholder="Search for Product"
                             [searchFn]="productSearch"
                             [searchWhileComposing]="true">
                    <ng-template ng-option-tmp let-item="item">
                      {{item?.productName}} <br/>
                      <small>{{item?.sku}}</small>
                    </ng-template>
                  </ng-select>
                </td>
                <td style="width: 200px"></td>
                <td style="width: 200px"><input type="text" id="selecetedQuantity" [(ngModel)]="quantity"
                                                class="form-control width-120"
                                                onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                                                [ngModelOptions]="{standalone: true}" required></td>
                <td style="width: 200px">
                  <a (click)="productSelected()" style="white-space: nowrap;">
                    <svg xmlns="http://www.w3.org/2000/svg" id="addProduct" class="mr-2" width="21" height="21"
                         viewBox="0 0 21.34 21.34">
                      <defs>
                        <style>.ab {
                          fill: #ee7125;
                        }</style>
                      </defs>
                      <path class="ab"
                            d="M14.045,3.375a10.67,10.67,0,1,0,10.67,10.67A10.67,10.67,0,0,0,14.045,3.375Zm5.489,11.747H15.122v4.412H12.968V15.122H8.556V12.968h4.412V8.556h2.155v4.412h4.412Z"
                            transform="translate(-3.375 -3.375)"/>
                    </svg>
                    Add Product
                  </a>
                </td>
              </tr>
              </tbody>
            </table>
            <hr class="wd">
          </div>
        </div>

        <div class="row mt-3" *ngIf="tabClicked == 'attributes'">
          <div class="col-lg-8 col-md-8">
            <div class="row mt-3">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="length">Length (cm)</label>
                  <input type="text" id="length" [(ngModel)]="length" maxlength="50" class="form-control"
                         [ngModelOptions]="{standalone: true}" required>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label for="width">Width (cm)</label>
                  <input type="text" id="width" [(ngModel)]="width" maxlength="50" class="form-control"
                         [ngModelOptions]="{standalone: true}" required>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="control-label" for="height">Height (cm)</label>
                  <input type="text" id="height" [(ngModel)]="height" maxlength="50" class="form-control"
                         [ngModelOptions]="{standalone: true}" required>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="weights">Weight (Kg)</label>
                  <input type="text" id="weights" [(ngModel)]="editInventory.weight" maxlength="50"
                         class="form-control" [ngModelOptions]="{standalone: true}" required>
                </div>
              </div>
              <div class="col-md-4" *ngIf="user.role !== 'ACCOUNT_OWNER'">
                <div class="form-group ">
                  <label class="control-label" for="rackLocation">Rack Location</label>
                  <input type="text" id="rackLocation" [(ngModel)]="editInventory.rackLocation"
                         class="form-control"
                         [ngModelOptions]="{standalone: true}" required>

                </div>
              </div>

              <div class="col-md-4" *ngIf="user.role !== 'ACCOUNT_OWNER'">
                <div class="form-group">
                  <label class="control-label" for="binLocation">Bin Location</label>
                  <input type="text" id="binLocation" [(ngModel)]="editInventory.binLocation" maxlength="50"
                         class="form-control" [ngModelOptions]="{standalone: true}" required>
                </div>
              </div>
            </div>


            <div class="row">
              <div class="col-md-4">
                <div class="form-group required">
                  <label class="control-label" for="minQuantity">Threshold Quantity</label>
                  <input type="text" id="minQuantity" [(ngModel)]="editInventory.minQuantity" maxlength="50"
                         class="form-control" onkeypress='return event.charCode >= 48 && event.charCode <= 57'
                         (blur)="typeMinQuantity()" [ngClass]="{'is-invalid':minQuantityError}"
                         [ngModelOptions]="{standalone: true}" required>
                </div>
              </div>
              <div class="col-md-4 required">
                <div class="form-group ">
                  <label class="control-label" for="color">Color</label>
                  <input type="text" id="color" [(ngModel)]="editInventory.productColor" (blur)="typeColor()"
                         [ngClass]="{'is-invalid':colorError}" class="form-control"
                         [ngModelOptions]="{standalone: true}" required>
                  <div id="colorError" class="invalid-feedback d-block shift-invalid-login"
                       [hidden]="!colorError">{{colorError}}
                  </div>
                </div>
              </div>

              <div class="col-md-4 required">
                <div class="form-group">
                  <label class="control-label" for="variant">Variant</label>
                  <input type="text" id="variant" [(ngModel)]="editInventory.productVariant" (blur)="typeVariant()"
                         class="form-control"
                         [ngModelOptions]="{standalone: true}" [ngClass]="{'is-invalid':variantError}">
                  <div id="variantError" class="invalid-feedback d-block shift-invalid-login"
                       [hidden]="!variantError">{{variantError}}
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>

        <div class="row mt-3" *ngIf="tabClicked == 'fulfilment'">
          <div class="col-lg-4 col-md-6">
            <div class="form-group">
              <div class="form-checkbox">
                <input type="checkbox" id="digitalProduct" [(ngModel)]="productAttr.digitalProduct"
                       [ngModelOptions]="{standalone: true}" required>
                <label for="digitalProduct">This is a digital product</label>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="form-group">
              <div class="form-checkbox">
                <input type="checkbox" id="lotProduct" [(ngModel)]="productAttr.lotProduct"
                       [ngModelOptions]="{standalone: true}" required>
                <label for="lotProduct">This is a lot product</label>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="form-group">
              <div class="form-checkbox">
                <input type="checkbox" id="dangerousGoods" [(ngModel)]="productAttr.dangerousGood"
                       [ngModelOptions]="{standalone: true}" required>
                <label for="dangerousGoods">This is classified as dangerous goods</label>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="form-group">
              <div class="form-checkbox">
                <input type="checkbox" id="productNumberScans" [(ngModel)]="productAttr.productNumberScans"
                       [ngModelOptions]="{standalone: true}" required>
                <label for="productNumberScans">This product requires serial number scans</label>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="form-group">
              <div class="form-checkbox">
                <input type="checkbox" id="wholeCaseProduct" [(ngModel)]="productAttr.wholeCaseProduct"
                       [ngModelOptions]="{standalone: true}" required>
                <label for="wholeCaseProduct">This product should be picked as a whole case</label>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="form-group">
              <div class="form-checkbox">
                <input type="checkbox" id="fragileProducts" [(ngModel)]="productAttr.fragileProduct"
                       [ngModelOptions]="{standalone: true}" required>
                <label for="fragileProducts">This product is fragile</label>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="form-group">
              <div class="form-checkbox">
                <input type="checkbox" id="foldableProduct" [(ngModel)]="productAttr.foldableProduct"
                       [ngModelOptions]="{standalone: true}" required>
                <label for="foldableProduct">This product is foldable</label>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="form-group">
              <div class="form-checkbox">
                <input type="checkbox" id="BubbleMailer" [(ngModel)]="productAttr.bubbleMailer"
                       [ngModelOptions]="{standalone: true}" required>
                <label for="BubbleMailer">Bubble Mailer</label>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="form-group">
              <div class="form-checkbox">
                <input type="checkbox" id="PolyMailer" [(ngModel)]="productAttr.PolyMailer"
                       [ngModelOptions]="{standalone: true}" required>
                <label for="PolyMailer">Poly Mailer</label>
              </div>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="form-group">
              <div class="form-checkbox">
                <input type="checkbox" id="essentialGoods" [(ngModel)]="productAttr.essentialGoods"
                       [ngModelOptions]="{standalone: true}" required>
                <label for="essentialGoods">Is an Essential Good</label>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-3" *ngIf="tabClicked == 'details'">
          <div class="table-responsive">
            <table class="table">
              <thead>
              <tr>
                <th>Order Number</th>
                <th>Order Type</th>
                <th>Order Date</th>
                <th>Quantity</th>
              </tr>
              </thead>
              <tbody>
              <tr *ngFor="let pro of editInventory?.historyActivities">
                <td>{{pro.activityOrderNumber}}</td>
                <td>{{(pro.activityType == 'WORK_ORDER' ? 'Work Order' :
                  (pro.activityType == 'STOCK' ? 'Inbound Orders' :
                    (pro.activityType == 'ORDER' ? 'Order' : "Orders")))}}
                </td>

                <td>{{pro.createdDate}}</td>
                <td>{{pro.quantity}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="form-btn-section" [hidden]="step != 1">
  <div class="row">
    <div class="col-12 text-right">
      <button type="reset" routerLink="/admin/sellerProductsList"
              class="btn btn-cancel">Cancel
      </button>
      <button [hidden]="editInventory.productType !== 'KIT'" type="submit" (click)="submitEditProducts('KIT')"
              class="btn btn-orange ml-3">Save
      </button>
      <button [hidden]="editInventory.productType === 'KIT'" type="submit"
              (click)="submitEditRegularProducts('REGULAR')" class="btn btn-orange ml-3">Save
      </button>
    </div>
  </div>
</div>
<div class="form-btn-section" [hidden]="step != 2">
  <div class="row mt-2">
    <div class="col-6 text-left">
      <button type="button" (click)="backToProduct()" class="btn btn-cancel">Back</button>
    </div>
    <div class="col-6 text-right">
      <button type="submit" (click)="addComponentToKit()" class="btn btn-orange ml-3">Save</button>
    </div>
  </div>
</div>

<!--start upload image model-box-->
<div class="modal fade style-modal" id="upLoadImage" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
     aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <div class="form-group btn-upload">
          <label for="file" style="height: 300px;width:300px;margin-left:31px;border:1px solid black; cursor:pointer;"
                 [ngStyle]="{'background-image':'url('+ productImage +')', 'background-position': 'center', 'background-size': 'cover'}"></label>
          <input type="file" class="form-control-file" (change)="loadImage($event)" id="file" accept="image/*">
        </div>
        <div class="text-right mt-3">
          <button type="button" class="btn btn-cancel" data-dismiss="modal" (click)="ignoreImage()">Cancel</button>
          <button type="button" (click)="submitImage()" class="btn btn-orange ml-2" data-dismiss="modal"
                  data-toggle="modal">Ok
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<!--end upload image model-box-->
